import { RoadStructuresPavementsAttributeConvert } from "@/attribute/convert/RoadStructuresPavementsAttributeConvert";
import { FeatureType } from "../define/FeatureType";
import { AbstractRoadStructuresLayerFactory } from "./AbstractRoadStructuresLayerFactory";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";

/**
 * 点検データ(舗装)レイヤ 出力クラス
 */
export class RoadStructuresPavementsLayerFactory extends AbstractRoadStructuresLayerFactory {
  /**
   * API取得用URL
   */

  URL_API = process.env.VUE_APP_ROAD_STRUCTURES_DB_API_URL + "/pavements";

  /**
   * アイコンURL
   */

  URL_LAYER_ICON = "./icon/layer/structures-pavements.png";

  /**
   * アイコンのサイズ
   */

  ICON_SIZE = 1;

  /**
   * 最大ズームレベル
   */

  LAYER_MAX_ZOOMLEVEL = 18;

  /**
   * 最小ズームレベル
   */

  LAYER_MIN_ZOOMLEVEL = 11;

  /**
   * コンテキストメニュー名称
   */
  CONTEXT_MENU_NAME = "点検DB_舗装";

  /**
   * 対象データ出力レイヤ
   */
  FEATURE_TYPE = FeatureType.Pavements;

  /**
   * 対象Attribute変換クラス
   */
  ATTRIBUTE_CONVERT = (geoJSON: any) =>
    new RoadStructuresPavementsAttributeConvert(geoJSON) as IAttributeConvert;
}
